<template>

  <div class="profile-billing-details box box-shadow" :class="{ 'box-collapse': collapse }">
    <!--{{ subscriptionActive }}-->
    <!--{{ subscriptionSelected }}-->
    <!--<hr/>-->
    <!--{{ subscriptionDetail }}-->
    <div v-if="collapse" v-b-toggle.collapseBillingDetails class="box-header">
      <h3>Manage Subscriptions</h3>
      <div class="box-toggle-icon"><i class="icon-chevron-top"></i></div>
    </div>

    <div v-else class="box-header">
      <h3>Manage Subscriptions</h3>
    </div>

    <div class="billingWarning" v-if="this.cardExpired || this.cardNearExpire">
      <i class="fas fa-exclamation"></i>
    </div>

    <b-collapse :visible="!collapse" id="collapseBillingDetails" class="box-main" >


      <template v-if="subscriptionActive">
        <div class=" option">
          <div class="row">
            <div class="col-md-4 mb-3">
              <h3 class="billingHeader pt-2"><i>Regular monitoring (subscription)</i></h3>
            </div>
            <div class="col-md-8 text-right">
              <!--<a @click.prevent="showSubscriptionModal = true" href="#" class="btn btn-outline-primary mr-2 d-inline-block">Change subscription</a>-->
              <a @click.prevent="cancelSubscription" href="#" class="btn btn-outline-muted d-inline-block">Cancel subscription</a>
            </div>
            <div class="col-md-12" v-if="subscriptionDetail">

              <div class="form-block">
                <div class="row ml-1 mr-1">

                  <div class="col-md-12 pl-5 pt-3 pr-5">
                    <strong class="smallTitle">You are currently on a {{ cyclePeriod }} month subscription cycle.</strong>
                    <p class="smallDesc">We will send you a Microba Insight Sampling Kit every {{cyclePeriod}} months. We will bill the card details entered below every {{cyclePeriod}} months and a kit will be dispatched once payment is successful. You can update your payment details or cancel anytime.</p>

                    <hr>
                    <div class="row mt-4">
                      <div class="col-4 pb-4">
                        <strong>Commenced on:</strong>
                        <span v-if="subscriptionDetail.subscribedDate">{{ formatDate(subscriptionDetail.subscribedDate) }}</span>
                        <span v-else>Unknown</span>
                        <!--12th September 2018-->
                      </div>
                      <div class="col-8 text-right mb-3" v-if="subscriptionDetail.kits.length > 0">
                        <strong>
                          <a v-if="!showKitDetails" @click.prevent="showKitDetails = true" href="#">+ SHOW KIT RECORD</a>
                          <a v-if="showKitDetails" @click.prevent="showKitDetails = false" href="#">- HIDE KIT RECORD</a>
                        </strong>
                      </div>
                    </div>
                    <div v-if="showKitDetails" class="row mb-4">
                      <div class="col-3">
                        <strong>Sampling Kit record:</strong>
                      </div>
                      <div class="col-9">
                        <div class="row" v-for="kit in subscriptionDetail.kits">
                          <div class="col"><strong>Sample ID:</strong> {{ kit.sampleId }}</div>
                          <div class="col"><strong>Dispatched on:</strong> {{ formatDateSimple(kit.redeemedDate) }}</div>
                          <div class="col"><strong>Card billed:</strong> {{ formatDateSimple(kit.redeemedDate) }}</div>
                          <hr class="mb-2 mt-2"/>
                        </div>
                      </div>
                    </div>
                    <hr>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class=" option">
          <div class="row">
            <div class="col-md-4 mb-3">
              <h3 class="billingHeader pt-2"><i>Payment details</i></h3>
            </div>
            <div class="col-md-8 text-right">

              <a @click.prevent="toggleEditBilling" href="#" :class="editPaymentClass"
                 class="btn btn-outline-primary mr-2 d-inline-block btnEditPayment">Update payment info</a>


              <div id="activateButton" class="toggleSwitch" :class="subscriptionClass">
                <div class="toggle">
                  <i class="fas" :class="subscriptionIcon"></i>
                </div>
                <span v-html="subscriptionText"></span>
              </div>

            </div>
            <div class="col-12">
              <div class="form-block">
                <div class="row ml-1 mr-1">

                  <div class="col-md-5 pl-5 pt-3 pr-5">
                    <h3 class="billingSubHeader">Payment method</h3>
                    <p style="font-size:0.95rem;" v-if="editBilling">
                      Microba does not store this information:<br/>
                      It is sent directly to our payment partner Stripe.
                      Your purchase confirmation will be emailed from Stripe and Microba.
                    </p>

                  </div>
                  <div class="col-md-7" v-if="cardDetails">
                    <div class="col-12" v-if="!editBilling">
                      <div class="ccBox">
                        &#9679;&#9679;&#9679;&#9679; &#9679;&#9679;&#9679;&#9679; &#9679;&#9679;&#9679;&#9679; {{ cardDetails.last4 }}
                        <div class="lock">
                          <span class="oi oi-lock-locked"></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12" v-if="editBilling">
                      <div class="row">
                        <div class="col-12">
                        <transition name="slide-fade">
                          <div v-if="ccError" class="alert alert-danger" role="alert">
                            {{ccError}}
                          </div>
                        </transition>

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col col-md-12">
                          <Card class='stripe-card form-control'
                                :class='{ complete }'
                                :stripe="PurchaseStripeKey"
                                :options='stripeOptions'
                                @change='onStripeChange'
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="ml-3 mr-3 pt-3" style="font-size: 0.95rem;">
                          You hereby authorise Microba to charge you automatically as per the
                          frequency of your subscription. If you don't cancel your subscription
                          before the offer ends (check your account page for details), you will automatically be charged
                          the price according to the subscription option you chose for this account.
                          Full terms and instructions on how to change are available here.

                          <div class="form-checkbox">
                            <input
                              v-model="subscriptionTerms"
                              type="checkbox"
                              name="subscriptionTerms"
                              id="subscriptionTerms"
                            />
                            <label class="small-label" for="subscriptionTerms"
                                   style="margin-top:20px; font-size: 0.95rem;">I agree to the&nbsp;<a href="https://www.microba.com/terms/"  target="_blank">Terms
                              and Conditions</a></label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <a @click.prevent="validatePay" href="#" class="btn btn-primary ml-1 d-inline-block">Save payment changes</a>
                          <a @click.prevent="toggleEditBilling" href="#" class="btn btn-outline-primary ml-1 d-inline-block">No changes required</a>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>


              </div>
            </div>
          </div>
        </div>

      </template>
      <template v-else>

        <div class="col-12 col-md-4 mb-4" >
          <a class="btn-card green" href="#" @click.prevent="openDescription" :class="{ 'btn-card-disabled' : subscriptionActive }">
            <div>
              <div class="fa-stack mb-2">
                <i class="far fa-circle fa-stack-2x"></i>
                <i class="fa fa-sync-alt fa-stack-1x"></i>
              </div>
              Subscribe for regular testing
            </div>
          </a>
        </div>



      </template>
    </b-collapse>

    <ModalSubscription
      :show="showSubscriptionModal"
      :product="additionalKit"
      heading=""
      @close="showSubscriptionModal = false"
    />


  </div>


</template>

<script>
  import FileUploadButton from '@/components/elements/FileUploadButton'
  import Button from '@/components/elements/DynamicButton'
  import { Card, createToken } from 'vue-stripe-elements-plus'
  import ModalSubscription from '@/components/models/ModalSubscription'
  import moment from 'moment'
  import _ from 'lodash'

  export default {
    name: 'ProfileBillingDetails',
    props: ['value', 'collapse'],
    components: {
      Button,
      FileUploadButton,
      Card,
      ModalSubscription
    },
    data: function () {
      return {
        file: null,
        parentEmail: '',
        skipConsent: false,
        stripeComplete: false,
        complete: false,
        editBilling: false,
        showSubscriptionModal: false,
        showKitDetails: false,
        subscriptionDetail: null,
        cardDetails: null,
        subscriptionTerms: false,
        ccError: '',
        billingUser: {
          firstName: '',
          lastName: ''
        },
        additionalKit: {
          amount: Number(process.env.PRICE_NEW_KIT) || 419.00,
          label: '1 Microba insight kit',
          orderType: 'NEW'
        }
      }
    },
    methods: {
      openDescription () {
        if (!this.subscriptionActive) {
          this.showSubscriptionModal = true
        }
      },
      toggleEditBilling () {
        this.editBilling = !this.editBilling
      },
      onChange: function (formData) {
        this.$store.dispatch('postParentalConsentForm', formData)
      },
      postParentalConsentEmail: function () {
        this.$store.dispatch('postParentalConsentEmail', this.parentEmail)
      },
      onStripeChange: function (e) {
        this.stripeComplete = e.complete
      },
      validatePay: function () {
        if (this.loading) {
          return
        }
        this.ccError = ''
        this.loading = true
        if (this.errors.any() || !this.stripeComplete) {
          this.loading = false
          this.ccError = 'Please complete credit card information.'
        } else {
          if (!this.subscriptionTerms) {
            this.loading = false
            this.ccError = 'Please agree to our Terms and Conditions.'
          } else {
            this.pay()
          }
        }
      },
      pay: function () {
        createToken().then(data => {
          if (data.error) {
            this.ccError = data.error.message
          } else {
            this.$store.dispatch('updateCard', data.token.id)
              .then(success => {
                this.loading = false
                this.success = true
                this.error = null
                this.editBilling = false
                this.fetchUserCard()
              })
              .catch(error => {
                console.log(error)
                this.loading = false
                this.success = false
                switch (error.response.status) {
                  case 402:
                    this.ccError = 'Your credit card transaction has been rejected.'
                    break
                  case 500:
                    this.ccError = 'We have experienced some technical issue with payment. Please try again. If problem persist, please contact us at 1300 974 621.'
                    break
                  default:
                    this.ccError = error.response.data.message
                }
              })
          }
        }).catch(error => {
          this.ccError = error.response.data.message
        })
      },
      fetchUserCard () {
        let payload = { }
        this.$store.dispatch('getUserCard', payload)
          .then(succuess => {
            this.cardDetails = succuess.data
          })
          .catch(error => {
            console.log('error', error.response.data.message)
          })
      },
      fetchSubscription () {
        if (this.subscriptionSelected) {
          let payload = {
            subscription: this.subscriptionSelected.id
          }
          this.$store.dispatch('getUserSingleSubscription', payload)
            .then(succuess => {
              this.subscriptionDetail = succuess.data
            })
            .catch(error => {
              console.log('error', error.response.data.message)
            })
        }
      },
      cancelSubscription () {
        let payload = { subscription: this.subscriptionSelected.id }
        this.$store.dispatch('cancelUserSubscription', payload)
          .then(succuess => {
            this.$store.dispatch('getUserSubscription')
            this.$store.dispatch('getUserKits')
          })
          .catch(error => {
            console.log('error', error.response.data.message)
          })
      },
      formatDate (date) {
        const theDate = moment(date)
        return theDate.format('Do MMMM Y')
      },
      formatDateSimple (date) {
        const theDate = moment(date)
        return theDate.format('D/MM/Y')
      }
    },

    computed: {
      creditCardDaysLeft () {
        if (this.cardDetails && this.cardDetails.expYear > 0 && this.cardDetails.expMonth > 0) {
          let ccDate = this.cardDetails.expYear + '-' + this.cardDetails.expMonth + '-01'
          let oneDay = 1000 * 60 * 60 * 24 // Get 1 day in milliseconds

          // Convert both dates to milliseconds
          let date1 = new Date()
          let date2 = new Date(ccDate)
          let date1MS = date1.getTime()
          let date2MS = date2.getTime()

          // Calculate the difference in milliseconds
          let differenceMS = date2MS - date1MS

          // Convert back to days and return
          return Math.round(differenceMS / oneDay)
        }
        return 999
      },
      cardExpired () {
        return (this.creditCardDaysLeft < 1)
      },
      cardNearExpire () {
        return (this.creditCardDaysLeft < 31)
      },
      cyclePeriod () {
        if (!this.subscriptionDetail) return

        if (this.subscriptionDetail.type === 'EVERY_THREE_MONTHS') {
          return 3
        } else if (this.subscriptionDetail.type === 'EVERY_SIX_MONTHS') {
          return 6
        } else if (this.subscriptionDetail.type === 'EVERY_TWELVE_MONTHS') {
          return 12
        }
      },
      subscriptionActive () {
        let subscriptions = this.$store.state.GET_SUBSCRIPTIONS_RESPONSE || []
        return _.find(subscriptions, (x) => { return x.cancelledDate === null && x.consumerUserId === this.user.id })
      },
      subscriptionSelected () {
        let subscriptions = this.$store.state.GET_SUBSCRIPTIONS_RESPONSE || []
        return _.find(subscriptions, (x) => { return x.cancelledDate === null && x.consumerUserId === this.user.id })
      },
      subscriptionText () {
        if (!this.cardExpired && !this.cardNearExpire) {
          return 'Card details are currently up to date.'
        } else if (!this.cardExpired && this.cardNearExpire) {
          return 'Card is about to expire, please update.'
        } else if (this.cardExpired) {
          return 'Card has expired, please update details.'
        }
        return 'Card not found, please update your details.'
      },
      subscriptionClass () {
        if (!this.cardExpired && !this.cardNearExpire) {
          return 'active'
        } else if (!this.cardExpired && this.cardNearExpire) {
          return 'warning'
        } else if (this.cardExpired) {
          return 'error'
        }
        return 'inactive'
      },
      subscriptionIcon () {
        if (!this.cardExpired && !this.cardNearExpire) {
          return 'fa-check'
        } else if (!this.cardExpired && this.cardNearExpire) {
          return 'fa-exclamation'
        } else if (this.cardExpired) {
          return 'fa-times'
        }
        return 'inactive'
      },
      editPaymentClass () {
        if (this.editBilling) {
          return 'btn-outline-muted'
        }
        return 'btn-outline-primary'
      },
      PurchaseStripeKey: function () {
        return process.env.STRIPE_KEY
      },
      user: function () {
        return this.$store.state.GET_USER_RESPONSE
      },
      pending: function () {
        return this.$store.state.POST_PARENTAL_CONSENT_PENDING
      },
      success: function () {
        return this.$store.state.POST_PARENTAL_CONSENT_SUCCESS
      },
      error: function () {
        return this.$store.state.POST_PARENTAL_CONSENT_FAILURE || false
      },
      errorMessage: function () {
        return this.$store.state.POST_PARENTAL_CONSENT_EMAIL_FAILURE
      },
      parentalEmailPending: function () {
        return this.$store.state.POST_PARENTAL_CONSENT_EMAIL_PENDING
      },
      parentalEmailSuccess: function () {
        return this.$store.state.POST_PARENTAL_CONSENT_EMAIL_SUCCESS
      },
      parentalEmailError: function () {
        return this.$store.state.POST_PARENTAL_CONSENT_EMAIL_FAILURE
      },
      errorDisplay: function () {
        if (this.error) {
          return this.error
        }
        return this.localError
      },
      isError: function () {
        if (this.error) {
          return true
        }
        return this.errorDisplay !== null
      },
      stripeOptions: function () {
        return {
          displayItems: [this.product],
          style: {
            base: {
              // Add your base input styles here. For example:
              'fontSize': '16px'
            }
          }
        }
      }
    },
    watch: {
      success: function () {
        this.$emit('onSuccess')
      },
      onError: function () {
        this.$emit('onError')
      },
      skipConsent () {
        this.$emit('onSkipConsent')
      },
      subscriptionActive: {
        handler: function (val, oldVal) {
          this.fetchSubscription()
        },
        deep: true
      }
    },
    mounted () {
      this.$store.dispatch('getUserSubscription')
      this.fetchUserCard()
    }
  }
</script>

<style scoped lang="scss">
  .option{
    padding-top: 40px;
    padding-bottom: 20px;
    border-bottom: 1px solid lightblue;
  }
  .error{
    color: red;
    font-size: 12px;
    text-align: right
  }

  .btn-success{
    color: white !important;
    line-height: 30px;
    position: relative;
    padding-right: 60px;
    text-align: right;
    margin-top: 1rem;
    .oi {
      font-size: 30px;
      position: absolute;
      top: 0;
      right: 10px;
    }
  }

  .form-radio{
    margin-top: 24px;
  }

  .inline-button button{
    margin-bottom: 0 !important;
  }

  .profile-billing-details{
    position:relative;
  }

  .billingHeader{
    font-weight:100;
    font-size:22px;
  }

  .billingWarning{
    position:absolute;
    top:-10px;
    right:40px;
    width:30px;
    height:30px;
    border-radius: 50%;
    background-color:#bf2828;
    text-align:center;
    color:#fff;
    font-weight:900;
    line-height: 28px;
  }

  .btn-outline-warning{
    padding: 0.625rem 1.5rem;
  }

  .form-block{
    position: initial !important;
    padding-left:0px !important;
    padding-right:0px !important;
  }

  .data-usage-concent{
    width: 100%;
  }
  embed{
    margin: 50px auto;
  }
  .radio-buttons{
    margin: 0px auto;
  }

  .btn-download {
    width:100% !important;
    max-width:300px;
    display: inline-block;
  }

  .box-header {
    display:flex;
    justify-content:space-between;
    flex-wrap:nowrap;
    align-items:center;

    @media (min-width:768px) {
      padding-bottom:1rem;
    }

    h3 {
      margin-bottom:0;
    }

    .box-toggle-icon {
      width:25px;
      height:25px;
      display:flex;
      justify-content:center;
      align-items:center;
      transition:all 0.5s ease;
      transform:rotate(0deg);
    }

    &.collapsed {
      .box-toggle-icon {
        transform:rotate(180deg);
      }
    }
  }

  .box-collapse {
    .box-header {
      cursor:pointer;
    }
  }

  .opt-in {
    border: 1px solid #ff8708;
    padding: 1rem 2rem;
    border-radius: 99em;
    label {
      margin: 0 auto;
      color: #ff8708;
    }
  }

  .opt-out {
    /*border: 1px solid #ff8708;*/
    padding: 1rem 2rem;
    border-radius: 99em;
    label {
      font-size: 0.94rem;
      margin: 0 auto;
      /*color: #ff8708;*/
    }
  }


  .profile-billing-details{
    position:relative;
  }

  .billingHeader{
    font-weight:100;
    font-size:22px;
  }
  .billingSubHeader{
    font-weight:400;
    font-size:18px;
  }

  .billingWarning{
    position:absolute;
    top:-10px;
    right:80px;
    width:30px;
    height:30px;
    border-radius: 50%;
    background-color:#bf2828;
    text-align:center;
    color:#fff;
    font-weight:900;
    line-height: 28px;
  }

  .btn-outline-warning{
    padding: 0.625rem 1.5rem;
  }

  .form-block{
    position: initial !important;
    padding-left:0px !important;
    padding-right:0px !important;

    hr {
      width:100%;
    }

    .smallTitle{
      display:block;
      font-size:14px;
      margin-bottom:10px;
      font-weight:500;
    }
    .smallDesc{
      font-size:14px;
    }
  }


  .sub-heading {
    font-size: 16px;
    line-height: 27px;
  }

  .btn-outline-muted{
    color: #c6c8ca;
    border-color: #c6c8ca;
  }

  .ccBox{
    background: #fff;
    font-size:18px;
    padding:5px 10px;
    margin-top:8px;
    position: relative;

    .lock{
      position: absolute;
      right:20px;
      top:5px;
    }
  }

  .btnEditPayment{
    float:right;
    display:block;
  }

  .toggleSwitch{
    margin-right:10px;
    float:right;
    width:355px;
    height:45px;
    border-radius: 25px;
    position:relative;

    display: flex;
    flex-direction: row;
    align-items: center;

    .toggle{
      height: 35px;
      width: 35px;
      border-radius: 50%;
      background-color:#fff;
      text-align: center;
      font-size: 22px;
      line-height: 38px;
    }

    &.inactive{
      background: #cfd1dd;

      .toggle{
        position:absolute;
        left: 8px;
      }

      span{
        text-align: right;
        padding-right:20px;
      }
    }

    &.active{
      background: #339795;
      color: #339795 !important;

      width:330px;
      .toggle{
        position:absolute;
        left: 8px;
        i {
          color: #339795 !important;
        }
      }

      span{
        text-align: right;
        padding-right:20px;
      }
    }
    &.warning{
      background: #f5d365;
      color: #f5d365;

      .toggle{
        position:absolute;
        left: 8px;
      }

      span{
        text-align: right;
        padding-right:20px;
      }
    }
    &.error{
      background: #cd0417;
      color: #cd0417;

      .toggle{
        position:absolute;
        left: 8px;
      }

      span{
        text-align: right;
        padding-right:20px;
      }
    }
    span{
      color: #fff;
      width: 100%;
      font-size:16px;
      font-weight: 400
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/ProfileBillingDetails.vue